import {
  AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer,
  BarChart, Bar, Cell, CartesianGrid,
} from "recharts";

const tooltipStyle = {
  background: "#18181b",
  border: "1px solid #3f3f46",
  borderRadius: 0,
  fontSize: 12,
  color: "#fafafa",
};

function Panel({ title, hint, children, testid }) {
  return (
    <div data-testid={testid} className="bg-[#18181b] border border-[#27272a] p-5">
      <div className="flex items-baseline justify-between mb-5">
        <h3 className="font-head text-lg font-normal text-[#fafafa]">{title}</h3>
        {hint && <span className="label-tiny">{hint}</span>}
      </div>
      {children}
    </div>
  );
}

export function TrendChart({ data }) {
  const fmt = (d) => {
    const dt = new Date(d);
    return dt.toLocaleDateString("pt-PT", { day: "2-digit", month: "2-digit" });
  };
  return (
    <Panel title="Novos Perfis por Dia" hint="Últimos 30 dias" testid="chart-trend">
      <ResponsiveContainer width="100%" height={260}>
        <AreaChart data={data} margin={{ left: -20, right: 8, top: 8 }}>
          <defs>
            <linearGradient id="gold" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#c8aa6e" stopOpacity={0.5} />
              <stop offset="100%" stopColor="#c8aa6e" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#27272a" vertical={false} />
          <XAxis dataKey="day" tickFormatter={fmt} stroke="#52525b" fontSize={11} tickLine={false} />
          <YAxis stroke="#52525b" fontSize={11} tickLine={false} axisLine={false} allowDecimals={false} />
          <Tooltip contentStyle={tooltipStyle} labelFormatter={fmt} />
          <Area type="monotone" dataKey="count" stroke="#c8aa6e" strokeWidth={2} fill="url(#gold)" name="Novos" />
        </AreaChart>
      </ResponsiveContainer>
    </Panel>
  );
}

export function SourceChart({ data }) {
  return (
    <Panel title="Perfis por Site" hint="Distribuição" testid="chart-source">
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} layout="vertical" margin={{ left: 20, right: 16 }}>
          <XAxis type="number" stroke="#52525b" fontSize={11} tickLine={false} axisLine={false} allowDecimals={false} />
          <YAxis type="category" dataKey="name" stroke="#a1a1aa" fontSize={11} width={90} tickLine={false} axisLine={false} />
          <Tooltip contentStyle={tooltipStyle} cursor={{ fill: "#27272a55" }} />
          <Bar dataKey="count" name="Perfis" radius={0}>
            {data.map((d, i) => (
              <Cell key={i} fill={d.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Panel>
  );
}

export function CityChart({ data }) {
  return (
    <Panel title="Top Cidades / Zonas" hint="Mais anúncios" testid="chart-city">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ left: -20, right: 8, top: 8 }}>
          <CartesianGrid stroke="#27272a" vertical={false} />
          <XAxis dataKey="city" stroke="#52525b" fontSize={10} tickLine={false} angle={-30} textAnchor="end" height={70} interval={0} />
          <YAxis stroke="#52525b" fontSize={11} tickLine={false} axisLine={false} allowDecimals={false} />
          <Tooltip contentStyle={tooltipStyle} cursor={{ fill: "#27272a55" }} />
          <Bar dataKey="count" fill="#c8aa6e" name="Perfis" radius={0} />
        </BarChart>
      </ResponsiveContainer>
    </Panel>
  );
}
